var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"p-5 bg-blue-600 text-white text-right"},[_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("Index")]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }